import React, { useEffect } from "react";

// Modified BrevoConversationsComponent
const BrevoConversationsComponent = () => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.BrevoConversationsID = "67cee1cbe963df22110e98ae";
      window["BrevoConversations"] =
        window["BrevoConversations"] ||
        function () {
          (window["BrevoConversations"].q =
            window["BrevoConversations"].q || []).push(arguments);
        };

      const script = document.createElement("script");
      script.async = true;
      script.src =
        "https://conversations-widget.brevo.com/brevo-conversations.js";

      if (document.head) document.head.appendChild(script);
    }
  }, []);

  return null;
};

export default BrevoConversationsComponent;
